import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./ComplexReactionGame.css";

const ComplexReactionGame = () => {
  const navigate = useNavigate();

  const initialForm = () => ({
    name: "",
    email: localStorage.getItem("rg_email") || "",
    sex: "",
    phone: localStorage.getItem("rg_phone") || "",
    age: "",
  });
  const [page, setPage] = useState("game");
  const [formData, setFormData] = useState(initialForm);
  const [circleColor, setCircleColor] = useState("red");
  const [reactionTime, setReactionTime] = useState(0);
  const [startTime, setStartTime] = useState(null);
  const [clickCount, setClickCount] = useState(0);
  const [wrongClickCount, setWrongClickCount] = useState(0);
  const [results, setResults] = useState([]);
  const [countdown, setCountdown] = useState(null);
  const [greenClicked, setGreenClicked] = useState(false);
  const [leaderboard, setLeaderboard] = useState([]);
  const [userRank, setUserRank] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // 🔥 VALID ATTEMPTS (<=150ms only)
const validAttempts = results
  .map(time => Number(time))
  .filter(time => time >= 0.150 && time <= 1); // 150ms to 1000ms only

const currentAverage =
  validAttempts.length > 0
    ? validAttempts.reduce((a, b) => a + b, 0) /
      validAttempts.length
    : null;


const startGame = () => {
  setGreenClicked(false);
  setCountdown(null);

  const delay = Math.random() * 2000 + 1000;

  setTimeout(() => {

    const colors = ["red", "blue", "green"];
    const randomColor =
      colors[Math.floor(Math.random() * colors.length)];

    setCircleColor(randomColor);

    if (randomColor === "green") {
      setStartTime(performance.now());
    } else {
      // ❗ If red or blue → automatically continue
      startGame();
    }

  }, delay);
};
  const handleCircleClick = () => {

    // Correct click
    if (circleColor === "green" && startTime && !greenClicked) {
      setGreenClicked(true);

      const endTime = performance.now();
      const timeTaken = ((endTime - startTime) / 1000).toFixed(3);

      setReactionTime(timeTaken);
      setClickCount(prev => prev + 1);
      setResults(prev => [...prev, timeTaken]);
      setCountdown(3);
    }

    // Wrong click
    else if (circleColor === "red" || circleColor === "blue") {
      setWrongClickCount(prev => prev + 1);
    }
  };


  const saveGameData = useCallback(async () => {
    try {
      const email = localStorage.getItem("rg_email");

      await axios.post("/save-complex-reaction", {
        email,
        results,
        wrongClickCount
      });
      
    } catch (error) {
      console.error("Error saving data:", error);
    }
  }, [results, wrongClickCount]);


  useEffect(() => {
    if (countdown !== null && countdown > 0) {
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
      return () => clearTimeout(timer);
    } else if (countdown === 0) {
      setCircleColor("red");
      if (clickCount < 5) {
        startGame();
      } else {
        setPage("result");
        saveGameData();
      }
    }
  }, [countdown, clickCount, saveGameData]);

    /* ================= FETCH LEADERBOARD ================= */

  useEffect(() => {
    const fetchLeaderboard = async () => {
      try {
        const email = localStorage.getItem("rg_email");
        const res = await axios.get(`/complexleaderboard?email=${email}`);

        setLeaderboard(res.data.leaderboard || []);
        setUserRank(res.data.userRank);
      } catch (error) {
        console.error("Leaderboard fetch error:", error);
      }
    };

    fetchLeaderboard();
  }, []);

  // On mount: require login and land on Ready screen
  useEffect(() => {
  const email = localStorage.getItem("rg_email");
  const phone = localStorage.getItem("rg_phone");
  const authed = localStorage.getItem("rg_auth") === "1";

  if (!email || !phone || !authed) {
    navigate("/complex-reaction");
    return;
  }

  setClickCount(0);
  setWrongClickCount(0);
  setReactionTime(0);
  setResults([]);
  setGreenClicked(false);

}, [navigate]);
 useEffect(() => {
  startGame();
}, []);

  

 const handleExit = async () => {
  await saveGameData();
  navigate("/complex-reaction");
};

  const handleTryAgain = () => {
    setPage("game");
    setClickCount(0);
    setWrongClickCount(0);
    setReactionTime(0);
    setResults([]);
    setGreenClicked(false);
    startGame();
  };
  

  return (
    <div className="containerr">
       {/* SHOW ONLY ON READY */}
      
       
     
      {page === "game" && (
        <div className="game-containerr">
          <div className={`circler ${circleColor}`} onClick={handleCircleClick}></div>
          <p className="reaction-timer">Reaction Time: {reactionTime* 1000} ms</p>
          {countdown !== null && <p className="countdownr">Countdown: {countdown}</p>}
          <p className="wrong-clickr">Wrong Clicks: {wrongClickCount}</p>
        </div>
      )}
    {page === "result" && (
  <div className="result-big-container">

    {/* LEFT SIDE – LEADERBOARD */}
    <div className="leaderboard-box">
      <h3>Leaderboard</h3>

      <table className="leaderboard-table">
        <thead>
          <tr>
            <th>Rank</th>
            <th>Name</th>
            <th>Best Reaction</th>
            
            <th>Medal</th>
          </tr>
        </thead>
        <tbody>
          {leaderboard.slice(0,5).map((player, index) => {

            let medal = "";
            if (index === 0) medal = "🥇";
            else if (index === 1) medal = "🥈";
            else if (index === 2) medal = "🥉";

            return (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{player.name}</td>
                <td>{(player.bestReaction * 1000).toFixed(0)} ms</td>
                <td>{medal}</td>
              </tr>
            );
          })}
        </tbody>
        </table>

        {userRank && (
          <div className="your-rank-box">
            Your Rank: {userRank.rank} <br />
            Avg Reaction: {(currentAverage * 1000).toFixed(0)} ms <br />
            Percentile: {userRank.percentile}%
          </div>
        )}
        
    

    </div>

    {/* RIGHT SIDE – USER RESULTS */}
    <div className="results-box">
      <h2>Your Attempts</h2>
      <ul>
        {results.map((time, index) => (
         <li>
          Attempt {index + 1}: {(time * 1000).toFixed(0)} ms
        </li>
        ))}
      </ul>

      <button onClick={handleTryAgain} className="try-again-buttonr">
        Try Again
      </button>

      <button onClick={handleExit} className="exit-buttonr">
        Exit
      </button>
    </div>

  </div>
)}
    </div>
  );
};

export default ComplexReactionGame;